import React from 'react';

interface EOMBannerProps {
  year: number;
  month: number;
  onView: () => void;
  onIgnore: () => void;
}

export function EOMBanner({ year, month, onView, onIgnore }: EOMBannerProps) {
  const monthName = new Date(year, month).toLocaleString('default', { month: 'long', year: 'numeric' });
  
  return (
    <div className="bg-gradient-to-r from-green-700 to-green-800 text-white rounded-xl shadow-lg p-4 mb-4 mx-6">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="font-semibold text-lg mb-1">End of Month Review Available</div>
          <div className="text-sm text-green-50">{monthName}</div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onIgnore}
            className="px-4 py-2 bg-white bg-opacity-30 hover:bg-opacity-30 rounded-lg font-medium transition-colors text-sm"
          >
            Ignore
          </button>
          <button
            onClick={onView}
            className="px-4 py-2 bg-white text-emerald-700 hover:bg-emerald-50 rounded-lg font-medium transition-colors text-sm"
          >
            View
          </button>
        </div>
      </div>
    </div>
  );
}

